import { createFileRoute } from '@tanstack/react-router';
import { RunsPage } from '@/features/payroll/runs/runs-page';
import { guardRoute } from '@/lib/route-guards';

export const Route = createFileRoute('/_app/payroll_/runs')({
  beforeLoad: ({ context }) => {
    guardRoute(context.auth, '/payroll/runs');
  },
  component: RunsPage,
});
